export default __webpack_public_path__ + "static/media/forkodes-logo.6e5daf7b.svg";